import React from 'react';
import { IntelligentPartnerHomePageAdminCourseDetailResponse } from 'src/api/types';
import { Space, Divider, Spin } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

interface StatisticsCardsProps {
    loading?: boolean;
    data?: IntelligentPartnerHomePageAdminCourseDetailResponse;
}

export const StatisticsCards: React.FC<StatisticsCardsProps> = ({ loading = false, data }) => {
    // 统计卡片数据
    const statisticsData = [
        {
            count: data?.releasedCount ?? 0,
            desc: /* 发布任务数 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.statisticsCards.numberOfPublishingTasks,
        },
        {
            count: data?.evaluationCount ?? 0,
            desc: /* 收获评价数 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.statisticsCards.harvestEvaluationNumber,
        },
        {
            count: data?.practiceCount ?? 0,
            desc: /* 练习人次 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.statisticsCards.practicePasses,
        },
        {
            count: data?.examCount ?? 0,
            desc: /* 考试人次 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.statisticsCards.examinations,
        },
    ];

    if (loading) {
        return (
            <div className="udesk-qa-web-coach-evaluation-overview-card-content">
                <Spin />
            </div>
        );
    }

    return (
        <div className="udesk-qa-web-coach-evaluation-overview-card-content">
            <Space split={<Divider type="vertical" />}>
                {statisticsData.map((item, index) => (
                    <div
                        key={index}
                        className="udesk-qa-web-coach-evaluation-overview-card-content-item"
                    >
                        <div className="udesk-qa-web-coach-evaluation-overview-card-content-item-count">
                            {item.count}
                        </div>
                        <div>{item.desc}</div>
                    </div>
                ))}
            </Space>
        </div>
    );
};
